import {
  IEntity, IEquatable, IPageRelation, IPageUnresolvedRelation, IUndecoratedMenuCategory,
  IUndecoratedMenuItem, IUndecoratedMenuPage, IUndecoratedNav
} from '../types';

export function isArray<T = unknown>(item: unknown): item is Array<T> {
  return Array.isArray(item);
}

export function isObject<T = Record<string, unknown>>(item: unknown): item is T {
  return item != null && typeof item === 'object' && !isArray(item);
}

export function isNotNullString(item: unknown): item is string {
  return typeof item === 'string' && Boolean(item);
}

export function isEquatable(item: unknown): item is IEquatable {
  return typeof item === 'number' || isNotNullString(item);
}

export function isEntity(item: unknown): item is IEntity {
  return isObject(item) && isEquatable(item.id);
}

export function isUnresolvedRelation(item: unknown): item is IPageUnresolvedRelation {
  return isObject(item) && isNotNullString(item.relationTo) &&
    (isEquatable(item.value) || isArray(item.value));
}

export function isRelation(item: unknown): item is IPageRelation {
  return isObject(item) && isNotNullString(item.relationTo) && isEntity(item.value);
}

export function isUndecoratedMenuItem(item: unknown): item is IUndecoratedMenuItem {
  return isObject(item) && (
    (item.type === 'category' && isEquatable((item as IUndecoratedMenuCategory).category)) ||
    (item.type === 'page' && isEquatable((item as IUndecoratedMenuPage).page.value))
  );
}

export function isUndecoratedNav<T>(item: unknown): item is IUndecoratedNav<T> {
  return isObject(item) && isUndecoratedMenuPage(item.nav);
}

export function isUndecoratedMenuCategory(item: unknown): item is IUndecoratedMenuCategory {
  return isObject(item) &&
    item.type === 'category' &&
    isNotNullString((item as IUndecoratedMenuCategory).category) &&
    item.id === undefined &&
    item.href === undefined;
}

export function isUndecoratedMenuPage(item: unknown): item is IUndecoratedMenuPage {
  return isObject(item) &&
    item.type === 'page' &&
    isObject(item.page) &&
    isNotNullString((item as IUndecoratedMenuPage).page.relationTo) &&
    isEquatable((item as IUndecoratedMenuPage).page.value);
}
